import * as React from 'react';

import classnames from 'classnames';

import {Price} from './price';

import styles from './plan-price.module.css';

type Props = {
    stickerPrice: string;
    price: string;
    justify: 'start' | 'end';
    includePlus?: boolean;
    includeDollarSign?: boolean;
    size?: 'small' | 'normal' | 'large' | 'extraLarge';
};

export function PlanPrice(props: Props) {
    const isDiscountApplied = props.price !== props.stickerPrice;

    const classNameList = classnames('flex', {
        ['justify-start']: props.justify === 'start',
        ['justify-end']: props.justify === 'end',
    });

    return (
        <div className={classNameList}>
            {isDiscountApplied ? (
                <div className={classnames('flex gap-8', styles.discount)}>
                    <Price
                        price={props.stickerPrice}
                        isBold={false}
                        strikethrough={true}
                        size={props.size || 'extraLarge'}
                        hasMarketingFont={true}
                    />
                    <Price
                        price={props.price}
                        color='green'
                        size={props.size || 'extraLarge'}
                        hasMarketingFont={true}
                        includePlus={props.includePlus}
                    />
                </div>
            ) : (
                <div className='flex'>
                    <Price
                        price={props.price}
                        size={props.size || 'extraLarge'}
                        hasMarketingFont={true}
                        includePlus={props.includePlus}
                        includeDollarSign={props.includeDollarSign}
                    />
                </div>
            )}
        </div>
    );
}
